import { getNodeType } from "@/common/graph";
import type { GraphNode } from "@packages/commons";

import { useParsedGraph } from "@/pages/models/release/GraphContext";
import { graphNodeByKey } from "@/components/GraphVisualisation/decisionGraphView";

import AttributeSummaryCard, { Attribute } from "@/components/AttributeSummaryCard/AttributeSummaryCard";
import type { AliasExpression, AttributeExpression, BaseExpression } from "@packages/compiler";
import { AliasInfo } from "./AliasCard";
import Icon from "@imminently/decisively-ui/Icon";
import ExpressionErrors from "@imminently/decisively-ui/ExpressionErrors";

type AttributeInfoProps = {
  expression: AttributeExpression;
  parent: string;
};

export const AttributeInfo = ({ expression, parent }: AttributeInfoProps) => {
  const { attributeId } = expression;
  const graph = useParsedGraph();
  const node = graphNodeByKey(graph, attributeId) as GraphNode;

  return (
    <AttributeSummaryCard
      node={node}
      extraTabs={[
        expression.alias
          ? {
              value: "alias",
              label: "Alias",
              icon: <Icon name="glossary" />,
              content: (
                <AliasInfo
                  expression={expression as BaseExpression as AliasExpression}
                  style={{ padding: 0 }}
                />
              ),
            }
          : null,

      ]}
    >
    </AttributeSummaryCard>
  );
};
